import en from '../../profileContent.en';

const about = {
    ...en.about,
    metaTitle: 'Profil',
    metaDescription:
      'Profil prowadzony przez założyciela: Oreste Twizeyimana jako inżynier backendu z doświadczeniem .NET w produkcji, mechatronicznym myśleniem systemowym i mocną komunikacją.',
    eyebrow: 'Profil założyciela',
    title: 'Inżynier stojący za Oracle Consults',
    lead:
      'Ta praktyka jest founder-led, ponieważ jej najmocniejszym aktywem nie jest szeroka tożsamość agencyjna, lecz konkretne połączenie backendowego delivery w produkcji, myślenia systemowego i jasnej komunikacji opartej na realnej pracy.',
    intro: [
      'Najbardziej stabilna interpretacja całego materiału nie brzmi „generyczny developer”. To inżynier backendowy od produkcji, myślenia systemowego, mentoringu i budowy oprogramowania osadzonego w realnych problemach operacyjnych.',
      'To ważne, ponieważ oferta konsultingowa na tej stronie nie jest marketingowym wymysłem. To skondensowana wersja tego, co spójnie potwierdzają doświadczenie, projekty i profil.'
    ],
    quickFactsTitle: 'W skrócie',
    quickFacts: [
      'Na co dzień w Bydgoszczy, z otwartością na współpracę zdalną, hybrydową i opcje relokacyjne.',
      'Komercyjny rdzeń: C#, .NET, ASP.NET Core, EF Core, SQL Server, integracje, testy i wsparcie produkcyjne.',
      'Kierunek rozwoju: Python, FastAPI, Flask, automatyzacja, diagnostyka i narzędzia blisko systemu.',
      'Wyróżniki: mechatronika, komunikacja wielojęzyczna, tutoring i myślenie systemowe.'
    ],
    sections: [
      {
        title: 'Co wyróżnia ten profil',
        paragraphs: [
          'Wiele wczesnoetapowych profili ma jedną lub dwie mocne przesłanki. Ten łączy realne doświadczenie backendowe w produkcji, poważną pracę dyplomową osadzoną w realnym problemie biznesowym, sensowną szerokość w Pythonie oraz ponadprzeciętną komunikację.',
          'Rezultatem jest konsultant, który potrafi wejść w techniczny detal bez gubienia problemu biznesowego ani ludzkiej strony delivery.'
        ]
      },
      {
        title: 'Dlaczego software operacyjny wraca tak często',
        paragraphs: [
          'Najsilniejsza osobista nić bierze się z bezpośredniego kontaktu z problemami magazynowymi i workflowowymi w małych firmach. Dlatego praca ciągle wraca do stanów magazynowych, rezerwacji, raportowania, automatyzacji i systemów ograniczających ręczną frikcję.',
          'To bardziej praktyczna empatia niż abstrakcyjna fascynacja: software powinien robić skomplikowane operacje bardziej niezawodnymi dla ludzi, którzy nimi zarządzają.'
        ]
      },
      {
        title: 'Fundament komercyjny',
        paragraphs: [
          'Komercyjne centrum ciężkości pozostaje Oponeo.pl, gdzie praca konsekwentnie wskazuje na API w ASP.NET Core, EF Core, SQL Server, integracje płatności i logistyki, tuning wydajności, refaktoryzację legacy, delivery Agile, testy i wsparcie produkcyjne.',
          'To doświadczenie ma znaczenie, bo potwierdza zdolność pracy wewnątrz systemów z realnym ruchem, realnymi zależnościami i realnymi konsekwencjami operacyjnymi.'
        ]
      },
      {
        title: 'Mechatronika i myślenie systemowe',
        paragraphs: [
          'Informatyka i mechatronika wzmacniają sposób myślenia oparty na integracji, pomiarze, niezawodności, sterowaniu, ograniczeniach i trybach awarii.',
          'W konsultingu backendowym przekłada się to na lepszy osąd architektoniczny, większą ostrożność w myśleniu o granicach i trafniejsze rozumienie zachowania systemu pod realną presją.'
        ]
      },
      {
        title: 'Komunikacja i uczenie',
        paragraphs: [
          'Tutoring programistyczny i nauczanie języków nie są przypisem. Wzmacniają rozkładanie złożonych tematów, klarowność, cierpliwość i umiejętność dopasowania wyjaśnienia do konkretnego odbiorcy.',
          'To ułatwia współpracę z klientami, founderami, productem i inżynierami, którzy potrzebują wspólnego obrazu tego, co robi system i dlaczego.'
        ]
      }
    ],
    valuesTitle: 'Styl pracy',
    values: [
      'Analityczny: szukam przyczyn, zależności, ograniczeń i trybów awarii zamiast patrzeć tylko na output feature’ów.',
      'Praktyczny: preferuję pracę związaną z operacjami, raportowaniem, workflowami, integracjami i widoczną użytecznością biznesową.',
      'Zorientowany na jakość: SOLID, clean architecture, testy, CI/CD i dokumentacja są częścią delivery.',
      'Adaptacyjny: mogę poruszać się między .NET, Pythonem, tutoringiem, automatyzacją i pracą platformową bez utraty tej samej tożsamości.'
    ],
    directionTitle: 'Kierunek',
    direction: [
      'Praca backendowa i platformowa w technicznie wymagających środowiskach produktowych.',
      'Systemy biznesowe i platformy operacyjne, w których niezawodność naprawdę ma znaczenie.',
      'Narzędzia w Pythonie, automatyzacja i backend usługowy.',
      'Backend z mocniejszym naciskiem na bezpieczeństwo i diagnostykę jako przewagę rozwojową.'
    ],
    practiceNote:
      'Konsulting backendowy prowadzony przez założyciela dla oprogramowania operacyjnego. Bydgoszcz, Polska. Dostępny zdalnie w Europie i międzynarodowo.',
    closing:
      'Sednem tego profilu nie jest po prostu „lubię kodować”. To raczej: chcę sprawiać, by złożone systemy działały niezawodnie dla prawdziwych ludzi.'
  };

export default about;
